import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { SeoPage } from '@domgen/dgx-fe-seo';
import { AppConfig } from 'apps/dg-self-fix/src/app/models/config/app-config.type';
import { CONFIG } from '@domgen/dgx-fe-config';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { SmartFixHubAnalyticsService } from 'libs/self-fix/data-access/src/lib/services/sf-hub-analytics/sf-hub-analytics-service';

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent],
  selector: 'redirect-to-mmr',
  templateUrl: './redirect-to-mmr.component.html',
  styleUrls: ['./redirect-to-mmr.component.scss'],
})
@SeoPage()
export class RedirectToMMRComponent implements OnInit {
  constructor(
    @Inject(CONFIG) private readonly config: AppConfig,
    private readonly smartFixHubAnalytics: SmartFixHubAnalyticsService
  ) {}

  planNumber: string | null = '';

  // not working in state atm
  retrievePlanNumber(): void {
    // const fallBackPlanNumber = '4LH0000114'; // Example plan number, replace as needed
    this.planNumber = localStorage.getItem('planNumber');
  }

  ngOnInit(): void {
    this.retrievePlanNumber();
  }

  redirectToMMR(): void {
    const baseUrl = this.config.claimsPage;
    this.sendToGa();
    if (this.planNumber) {
      const fullUrl = `${baseUrl}/my-plans/${this.planNumber}/claims`;
      window.location.href = fullUrl;
    } else {
      window.location.href = this.config.plansHomePage;
    }
  }

  sendToGa(): void {
    this.smartFixHubAnalytics.trackEvent({
      eventCategory: 'sf-hub',
      eventAction: 'need cancel repair',
      eventLabel: 'Cancel your repair booking',
      event: 'genericGAEvent',
    });
  }
}
